module.exports = __webpack_public_path__ + "img/bh_5.2f363e85.jpg";